import { API_ROUTE_TRADE_IN_ORDER, API_ROUTE_TRADE_IN_ORDERS } from '@/api/apiRoutes'
import { get, post, put } from '@/util/auth'

const tradeInStatusesOriginal = [
  'PRICE_REQUEST',
  'PRICE_ESTIMATION',
  'ACCEPTANCE',
  'SENT',
  'FINAL_PRICING',
  'FINISHED',
  'REJECTED',
] as const
export type StatusOriginal = (typeof tradeInStatusesOriginal)[number]

export const tradeInStatuses = [
  'PRICE_REQUEST',
  'INCOMING',
  'SENT',
  'FINAL_PRICING',
  'FINISHED',
  'REJECTED',
] as const
export type Status = (typeof tradeInStatuses)[number]
export type Grade = 'A' | 'B'

type TradeInOrderOriginal = {
  orderId: string
  customerId: string
  customerName: string
  orderStatus: StatusOriginal
  partnerId: string
  assetId: string
  productName: string | null
  assetDate: string | null
  finalGrade: Grade | null
  finalPrice: number | string | null
  imeiSerialNumber: string | null
  grade: Grade | null
  estimatedPrice: number | string | null
}

const IS_NEW_BACKEND_API = true

// eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
export const getTradeInOrders = async (customerId: number) => {
  let orders = await get<TradeInOrderOriginal[]>(
    `${API_ROUTE_TRADE_IN_ORDERS}?customerId=${customerId}`,
    IS_NEW_BACKEND_API
  )
  orders = orders.map(order => ({
    ...order,
    estimatedPrice:
      order.orderStatus === 'PRICE_REQUEST' && order.estimatedPrice === null
        ? 0
        : order.estimatedPrice,
    finalPrice: order.orderStatus === 'SENT' && order.finalPrice === null ? 0 : order.finalPrice,
  }))

  const orderCounter = orders.reduce<Record<Partial<Status | 'ALL'>, number>>(
    (acc, order) => {
      if (order.orderStatus === 'PRICE_ESTIMATION' || order.orderStatus === 'ACCEPTANCE') {
        acc['INCOMING']++
      } else {
        acc[order.orderStatus]++
      }
      acc['ALL']++
      return acc
    },
    {
      ALL: 0,
      PRICE_REQUEST: 0,
      INCOMING: 0,
      SENT: 0,
      FINAL_PRICING: 0,
      FINISHED: 0,
      REJECTED: 0,
    }
  )
  return { orders, orderCounter }
}

export const getTradeInOrder = async (orderId: string) => {
  const order = await get<TradeInOrderOriginal>(
    `${API_ROUTE_TRADE_IN_ORDER.replace(':orderId', orderId)}`,
    IS_NEW_BACKEND_API
  )

  return order
}

export const postTradeInOrderStatus = async (orderId: string, status: Status, comment?: string) => {
  const payload = {
    NewStatusId: status,
    Comment: comment,
  }
  const response = await post(
    `${API_ROUTE_TRADE_IN_ORDERS}/${orderId}/status`,
    payload,
    IS_NEW_BACKEND_API
  )

  return response
}

type UpdateOrderType = {
  orderId: string
  newStatusCode: string
  comment: string
  price: number
  grade: string
  currencyCode: string
}
export type UpdateOrdersType = {
  orders: Array<UpdateOrderType>
}
export const updateTradeInOrders = async ({ payload }: { payload: UpdateOrdersType }) =>
  await put(API_ROUTE_TRADE_IN_ORDERS, payload, IS_NEW_BACKEND_API)
